<div class="max-w-[1780px] mx-auto px-4 2xl:flex 2xl:gap-8 2xl:items-start">
  <!-- 2XL STICKY TIMELINE (GAUCHE) -->
  <aside class="hidden 2xl:flex flex-col gap-3 w-64 shrink-0 sticky top-2 z-20">
    @if (!isAdmin()) {
      <div class="flex flex-col gap-2">
        <button
          mat-button
          [matMenuTriggerFor]="sidebarViewSheetMenu"
          class="text-gray-11 hover:text-indigo-11 flex items-center justify-between gap-1.5 font-medium transition-colors w-full !px-3 !py-1 hover:bg-gray-a2"
        >
          <div class="flex items-center gap-1.5">
            <mat-icon class="text-sm! text-indigo-9">visibility</mat-icon>
            <span>Voir la fiche</span>
          </div>
          <mat-icon class="text-xs! text-gray-9">expand_more</mat-icon>
        </button>

        <mat-menu #sidebarViewSheetMenu="matMenu" class="shadow-xl">
          <a mat-menu-item [routerLink]="['/properties', property()._id]">
            <mat-icon class="text-indigo-9!">visibility</mat-icon>
            <div class="flex flex-col text-left">
              <span class="font-medium text-xs">Fiche complète du bien</span>
              <span class="text-[10px] text-gray-10 leading-tight">Toutes vos informations et documents</span>
            </div>
          </a>
          <a mat-menu-item [routerLink]="['/properties', property()._id, 'preview']">
            <mat-icon class="text-indigo-9!">badge</mat-icon>
            <div class="flex flex-col text-left">
              <span class="font-medium text-xs">Aperçu agent (sans mandat)</span>
              <span class="text-[10px] text-gray-10 leading-tight"
                >Ce que voient les agents avant de postuler</span
              >
            </div>
          </a>
        </mat-menu>
      </div>
    }
    <div
      class="rounded-3xl border border-gray-6/60 bg-white/70 dark:bg-gray-1/70 backdrop-blur-xl p-4 shadow-sm"
    >
      <div
        class="text-[11px] font-bold uppercase tracking-wider text-gray-10 px-2.5 py-1 mb-2 flex items-center gap-2 border-b border-gray-5/60 pb-2"
      >
        <mat-icon
          class="w-4! h-4! text-[16px]! flex items-center justify-center leading-none select-none shrink-0 text-indigo-9!"
        >
          format_list_bulleted
        </mat-icon>
        <span>Sommaire du bien</span>
      </div>
      <etxe-property-section-nav [sections]="navSections()" variant="timeline" />
    </div>
  </aside>

  <!-- MAIN CONTENT CONTAINER -->
  <div
    class="flex-1 min-w-0 flex flex-col gap-8 md:grid md:grid-cols-2 max-w-7xl 2xl:max-w-none mx-auto 2xl:mx-0 mb-8"
  >
    <!-- STICKY HEADER BADGES, SUMMARY & INTEGRATED SECTION NAV -->
    <etxe-property-status-header
      class="md:col-span-2 lg:sticky lg:top-2 lg:z-30"
      [property]="property()"
      [editable]="canEdit()"
      [sections]="navSections()"
      (editRequested)="onHeaderEditRequested($event)"
      (manageSettings)="goToSettings()"
      (propertyUpdated)="propertyUpdated.emit($event)"
    />

    <!-- DEFINITION & SELLER CARD (READ-ONLY) -->
    <etxe-property-definition-display
      id="definition-section"
      class="md:col-span-2 scroll-mt-8 lg:scroll-mt-64 2xl:scroll-mt-44"
      [definition]="property().definition"
      [marketStatus]="property().marketStatus"
    />

    <!-- PHOTOS CARD -->
    <etxe-property-photos-edit
      id="photos-section"
      class="md:col-span-2 scroll-mt-8 lg:scroll-mt-64 2xl:scroll-mt-44"
      [property]="property()"
      [editable]="canEdit()"
      [editMode]="editingSection() === PropertyCreationStep.PHOTOS"
      [saving]="!!savingState()[PropertyCreationStep.PHOTOS]"
      (editToggled)="startEdit(PropertyCreationStep.PHOTOS)"
      (cancelToggled)="cancelEdit()"
      (dtoChanged)="onDtoChanged(PropertyCreationStep.PHOTOS, $any($event))"
      (submitted)="saveSection(PropertyCreationStep.PHOTOS)"
    ></etxe-property-photos-edit>

    <!-- PRESENTATION CARD -->
    <etxe-property-presentation-edit
      id="presentation-section"
      class="md:col-span-2 scroll-mt-8 lg:scroll-mt-64 2xl:scroll-mt-44"
      [property]="property()"
      [editable]="canEdit()"
      [editMode]="editingSection() === PropertyCreationStep.PRESENTATION"
      [saving]="!!savingState()[PropertyCreationStep.PRESENTATION]"
      (editToggled)="startEdit(PropertyCreationStep.PRESENTATION)"
      (cancelToggled)="cancelEdit()"
      (dtoChanged)="onDtoChanged(PropertyCreationStep.PRESENTATION, $any($event))"
      (submitted)="saveSection(PropertyCreationStep.PRESENTATION)"
    ></etxe-property-presentation-edit>

    <!-- FINANCIALS CARD -->
    <etxe-property-financials-edit
      id="financials-section"
      class="md:col-span-2 xl:col-span-1 scroll-mt-8 lg:scroll-mt-64 2xl:scroll-mt-44"
      [property]="property()"
      [editable]="canEdit()"
      [editMode]="editingSection() === PropertyCreationStep.FINANCIALS"
      [saving]="!!savingState()[PropertyCreationStep.FINANCIALS]"
      (editToggled)="startEdit(PropertyCreationStep.FINANCIALS)"
      (cancelToggled)="cancelEdit()"
      (dtoChanged)="onDtoChanged(PropertyCreationStep.FINANCIALS, $any($event))"
      (submitted)="saveSection(PropertyCreationStep.FINANCIALS)"
    ></etxe-property-financials-edit>

    <!-- KEY INFOS CARD -->
    <etxe-property-key-infos-edit
      id="key-infos-section"
      class="md:col-span-2 xl:col-span-1 scroll-mt-8 lg:scroll-mt-64 2xl:scroll-mt-44"
      [property]="property()"
      [editable]="canEdit()"
      [editMode]="editingSection() === PropertyCreationStep.KEY_INFOS"
      [saving]="!!savingState()[PropertyCreationStep.KEY_INFOS]"
      (editToggled)="startEdit(PropertyCreationStep.KEY_INFOS)"
      (cancelToggled)="cancelEdit()"
      (dtoChanged)="onDtoChanged(PropertyCreationStep.KEY_INFOS, $any($event))"
      (submitted)="saveSection(PropertyCreationStep.KEY_INFOS)"
    ></etxe-property-key-infos-edit>

    <!-- MANDATE CARD -->
    @if (property().mandate) {
      <etxe-property-mandate-edit
        id="mandate-section"
        class="md:col-span-2 scroll-mt-8 lg:scroll-mt-64 2xl:scroll-mt-44"
        [property]="property()"
        [editable]="canEdit()"
        [editMode]="editingSection() === MANDATE_STEP"
        [saving]="!!savingState()[MANDATE_STEP]"
        (editToggled)="startEdit(MANDATE_STEP)"
        (cancelToggled)="cancelEdit()"
        (dtoChanged)="onDtoChanged(MANDATE_STEP, $any($event))"
        (submitted)="saveSection(MANDATE_STEP)"
      ></etxe-property-mandate-edit>
    }

    <!-- CONSTRUCTION CARD -->
    <etxe-property-construction-edit
      id="construction-section"
      class="md:col-span-2 scroll-mt-8 lg:scroll-mt-64 2xl:scroll-mt-44"
      [property]="property()"
      [editable]="canEdit()"
      [editMode]="editingSection() === CONSTRUCTION_STEP"
      [saving]="!!savingState()[CONSTRUCTION_STEP]"
      (editToggled)="startEdit(CONSTRUCTION_STEP)"
      (cancelToggled)="cancelEdit()"
      (dtoChanged)="onDtoChanged(CONSTRUCTION_STEP, $any($event))"
      (submitted)="saveSection(CONSTRUCTION_STEP)"
    ></etxe-property-construction-edit>

    <!-- CHARACTERISTICS CARD -->
    <etxe-property-characteristics-edit
      id="characteristics-section"
      class="md:col-span-2 scroll-mt-8 lg:scroll-mt-64 2xl:scroll-mt-44"
      [property]="property()"
      [editable]="canEdit()"
      [editMode]="editingSection() === PropertyCreationStep.CHARACTERISTICS"
      [saving]="!!savingState()[PropertyCreationStep.CHARACTERISTICS]"
      (editToggled)="startEdit(PropertyCreationStep.CHARACTERISTICS)"
      (cancelToggled)="cancelEdit()"
      (dtoChanged)="onDtoChanged(PropertyCreationStep.CHARACTERISTICS, $any($event))"
      (submitted)="saveSection(PropertyCreationStep.CHARACTERISTICS)"
    ></etxe-property-characteristics-edit>

    <!-- DPE CARD -->
    <etxe-property-dpe-edit
      id="dpe-section"
      class="md:col-span-2 scroll-mt-8 lg:scroll-mt-64 2xl:scroll-mt-44"
      [property]="property()"
      [editable]="canEdit()"
      [editMode]="editingSection() === PropertyCreationStep.DPE"
      [saving]="!!savingState()[PropertyCreationStep.DPE]"
      (editToggled)="startEdit(PropertyCreationStep.DPE)"
      (cancelToggled)="cancelEdit()"
      (dtoChanged)="onDtoChanged(PropertyCreationStep.DPE, $any($event))"
      (submitted)="saveSection(PropertyCreationStep.DPE)"
    ></etxe-property-dpe-edit>

    <!-- GEOSPATIAL CARD -->
    <div id="geospatial-section" class="md:col-span-2 scroll-mt-8 lg:scroll-mt-64 2xl:scroll-mt-44">
      <etxe-property-geospatial-display
        [property]="property()"
        [fetchData]="true"
        [showHero]="true"
        [showRefreshButton]="false"
        [collapsible]="true"
        [isOwner]="true"
        (propertyRefreshed)="propertyUpdated.emit($event)"
      ></etxe-property-geospatial-display>
    </div>

    <!-- LOCATION CARD -->
    <etxe-property-location-edit
      id="location-section"
      class="md:col-span-2 scroll-mt-8 lg:scroll-mt-64 2xl:scroll-mt-44"
      [property]="property()"
      [allowEdit]="canEdit()"
      [editMode]="editingSection() === PropertyCreationStep.LOCATION"
      [saving]="!!savingState()[PropertyCreationStep.LOCATION]"
      (editToggled)="startEdit(PropertyCreationStep.LOCATION)"
      (cancelToggled)="cancelEdit()"
      (dtoChanged)="onDtoChanged(PropertyCreationStep.LOCATION, $any($event))"
      (submitted)="saveSection(PropertyCreationStep.LOCATION)"
    ></etxe-property-location-edit>

    <!-- CADASTRAL CARD -->
    <div id="cadastral-section" class="md:col-span-2 scroll-mt-8 lg:scroll-mt-64 2xl:scroll-mt-44">
      <mat-card class="rounded-2xl border border-gray-6 shadow-sm h-full overflow-hidden">
        <div class="bg-gray-1 py-4 px-6 border-b border-gray-6 flex items-center justify-between w-full">
          <div class="flex items-center gap-3">
            <div class="flex h-10 w-10 items-center justify-center rounded-xl bg-indigo-3 text-indigo-11">
              <mat-icon>grid_4x4</mat-icon>
            </div>
            <h3 class="text-lg! font-bold! m-0! text-gray-12!">Cadastre et parcelle</h3>
          </div>
          <div class="flex items-center gap-2">
            @if (property().geospatial?.cadastral?.totalSurface; as surface) {
              <span
                class="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-jade-a2 text-jade-11 border border-jade-a4 shadow-2xs"
              >
                <mat-icon class="text-sm! w-4! h-4! text-jade-10">verified</mat-icon>
                <span>{{ surface | number: '1.0-0' : 'fr-FR' }} m²</span>
              </span>
            }
            <button
              mat-icon-button
              type="button"
              class="text-gray-11 hover:text-gray-12 hover:bg-gray-a3 transition-colors rounded-full"
              (click)="cadastralExpanded.set(!cadastralExpanded())"
              [title]="cadastralExpanded() ? 'Replier le volet' : 'Déplier le volet'"
              [attr.aria-label]="cadastralExpanded() ? 'Replier le volet' : 'Déplier le volet'"
            >
              <mat-icon>{{ cadastralExpanded() ? 'expand_less' : 'expand_more' }}</mat-icon>
            </button>
          </div>
        </div>
        @if (cadastralExpanded()) {
          <mat-card-content class="p-6">
            <etxe-property-cadastral-card
              [cadastral]="property().geospatial?.cadastral"
              [addressLabel]="property().location?.address?.label || property().location?.address?.street"
              [cityCode]="property().location?.address?.cityCode"
              [coordinates]="property().location?.coordinates"
              [isOwner]="true"
              [propertyId]="property()._id"
              variant="flat"
            />
          </mat-card-content>
        }
      </mat-card>
    </div>

    <!-- DOCUMENTS & JUSTIFICATIFS (ANTI-FAKE) -->
    <etxe-property-documents-edit
      id="documents-section"
      class="md:col-span-2 scroll-mt-8 lg:scroll-mt-64 2xl:scroll-mt-44"
      [property]="property()"
      [editable]="canEdit()"
      (propertyUpdated)="onPropertyDocumentsUpdated($event)"
    ></etxe-property-documents-edit>

    <!-- SETTINGS CARD -->
    <div id="settings-section" class="md:col-span-2 scroll-mt-8 lg:scroll-mt-64 2xl:scroll-mt-44">
      <mat-card
        class="rounded-3xl border border-gray-6/60 shadow-sm overflow-hidden bg-white/70 dark:bg-gray-1/70 backdrop-blur-xl"
      >
        <div class="bg-gray-2/60 py-4 px-6 flex flex-row items-center justify-between w-full">
          <div class="flex items-center gap-3">
            <div class="flex h-10 w-10 items-center justify-center rounded-xl bg-indigo-a3 text-indigo-9">
              <mat-icon
                class="w-5! h-5! text-[20px]! flex items-center justify-center leading-none text-indigo-9!"
              >
                settings
              </mat-icon>
            </div>
            <div>
              <h3 class="text-base font-bold text-gray-12 m-0">Paramètres de l'annonce</h3>
              <p class="text-xs text-gray-11 m-0">
                Gérez la visibilité, les préférences et les actions avancées
              </p>
            </div>
          </div>
          @if (isAdmin()) {
            <div class="flex items-center gap-2">
              <button
                mat-flat-button
                [matMenuTriggerFor]="adminStateMenu"
                class="primary flex items-center gap-2"
              >
                <mat-icon class="text-sm!">tune</mat-icon>
                <span>Modifier le statut</span>
              </button>
              <mat-menu #adminStateMenu="matMenu">
                <button
                  mat-menu-item
                  (click)="openAdminStateDialog(EntityStatus.ACTIVE)"
                  [disabled]="property().state.status === EntityStatus.ACTIVE"
                >
                  <mat-icon class="text-jade-9!">check_circle</mat-icon>
                  <span>Activer (Public)</span>
                </button>
                <button
                  mat-menu-item
                  (click)="openAdminStateDialog(EntityStatus.DEACTIVATED)"
                  [disabled]="property().state.status === EntityStatus.DEACTIVATED"
                >
                  <mat-icon class="text-amber-9!">visibility_off</mat-icon>
                  <span>Désactiver (Masqué)</span>
                </button>
                <button
                  mat-menu-item
                  (click)="openAdminStateDialog(EntityStatus.DELETED)"
                  [disabled]="property().state.status === EntityStatus.DELETED"
                >
                  <mat-icon class="text-ruby-9!">delete</mat-icon>
                  <span>Supprimer</span>
                </button>
              </mat-menu>
            </div>
          } @else {
            <button mat-flat-button (click)="goToSettings()" class="primary">Gérer</button>
          }
        </div>
      </mat-card>
    </div>

    <!-- MODERATION CARD (ADMIN ONLY) -->
    @if (isAdmin()) {
      <etxe-property-moderation-display
        id="moderation-section"
        class="md:col-span-2 scroll-mt-8 lg:scroll-mt-64 2xl:scroll-mt-44"
        [property]="property()"
        (propertyUpdated)="propertyUpdated.emit($event)"
      />

      <!-- ASSOCIATED USERS CARD (ADMIN ONLY: createdBy & owner) -->
      <etxe-property-associated-users
        id="associated-users-section"
        class="md:col-span-2 scroll-mt-8 lg:scroll-mt-64 2xl:scroll-mt-44"
        [property]="property()"
      />
    }
  </div>
</div>
